import React from 'react'
import { Upload, Form, Icon, Input, Button, Row, Col, DatePicker } from 'antd';

export const ConsentFormStep2 = (props) => {

    var consentExistsText;

    if (props.currentStep !== 'Step 2') {
      return null
    }

    return(
        <div className="form-group">

            <h3 style={{ display: 'inline-block !important' }}>Subject Found! Please verify details below:</h3>

            <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>

            <h4 style={{  display: 'inline-block !important' }}>Consent Exists: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
            {props.consentExists === true ? <div>Yes</div> : <div>No</div> }
            </span></h4>

            {
              (() => {

                if (props.consentExists) {
                    return (
                        <div className="consent-exists">
                            <h4 style={{  display: 'inline-block !important' }}>Consent Date: <h5 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsDate}</h5></h4>
                            <h4 style={{  display: 'inline-block !important' }}>Consent Type: <h5 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsType}</h5></h4>
                            <h4 style={{  display: 'inline-block !important' }}>Consent Person: <h5 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsPersonType}</h5></h4>
                            <h4 style={{  display: 'inline-block !important' }}>Consent Method: <h5 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsMethodType}</h5></h4>
                            {['Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && <h4 style={{  display: 'inline-block !important' }}>Consent Email Status: <h5 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentExistsEmailStatus.replace(/_/g, ' ')}</h5></h4>}
                            <h4 style={{  display: 'inline-block !important' }}>Consent Document Link: <h5 style={{ color: '#4CDEF5', display: 'inline-block' }}><a href={props.consentExistsLink} target="_blank">Consent Document</a></h5></h4>
                        </div>
                    );
                }

              })()
            }


            <Form.Item>
                {props.getFieldDecorator('consentPersonType', {
                    initialValue: props.consentPersonType,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please select who will be providing consent'
                    }],
                })(
                  <label>
                    <h5>
                    Who will be providing Consent?
                    </h5>
                      <select id="consentPersonType" name="consentPersonType" autoFocus size="large" className="ant-input ant-input-lg">
                        <option value="">Consent Person</option>
                        <option value="Patient">Patient</option>
                        <option value="Surrogate">Surrogate</option>
                      </select>
                  </label>
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('consentMethodType', {
                    initialValue: props.consentMethodType,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please select the type of consent desired'
                    }],
                })(
                  <label>
                    <h5>
                    Consent Type
                    </h5>
                      <select id="consentMethodType" name="consentMethodType" size="large" className="ant-input ant-input-lg">
                        <option value="">Consent Type</option>
                        <option value="Electronic">Electronic Signature</option>
                        <option value="Email">Email</option>
                        {/*{props.consentPersonType === 'Patient' && <option value="RegainedCapacity">Electronic Signature - Regained Capacity Form</option>}*/}
                        {/*{props.consentPersonType === 'Patient' && <option value="EmailRegainedCapacity">Email - Regained Capacity Form</option>}*/}
                        <option value="Paper">Paper</option>
                      </select>
                  </label>
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('consentOverwrite', {
                    initialValue: props.consentOverwrite,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'You need to agree to override data if you wish to proceed with this entry!'
                    }],
                })(
                  <label>
                    <h5>
                    Overwrite existing consent, if it exists?
                    </h5>
                      <select id="consentOverwrite" name="consentOverwrite" size="large" className="ant-input ant-input-lg">
                        <option value="">Overwrite Consent?</option>
                        <option value="yes">Yes</option>
                        <option value="">No</option>
                      </select>
                  </label>
                )}
            </Form.Item>


       </div>

    );
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeRedDeerCalgary/Step2.js